export default __webpack_public_path__ + "static/media/google-play.e02f7cc0.svg";